import React, { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import { track } from '~/src/dash/analytics/analytics';
import { SimpleTabs } from '~/src/dash/components/tabs/SimpleTabs';
import { SimpleTabSections } from '~/src/dash/components/tabs/SimpleTabSections';
import { Panel, Panels, spacing, usePublicaTranslation } from '~/src/dash/publicaUI';
import { IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { useBaseConfig, useBaseStore } from '~/src/dash/views/base/contexts';
import { BidderGroupsListView } from '~/src/dash/views/bidders/Bidders/tabs/BidderGroupsListView';
import { BiddersDemandSourceSettings } from '~/src/dash/views/bidders/Bidders/tabs/BiddersDemandSourceSettings';
import { BiddersListView } from '~/src/dash/views/bidders/Bidders/tabs/BiddersListView';
import { BiddersListContext } from '~/src/dash/views/bidders/contexts';
import { TopBar } from '~/src/dash/views/topbar/TopBar';

export const Bidders = () => {
  const { t } = usePublicaTranslation();
  const { user } = useBaseStore();
  const { Bidders } = useBaseConfig();
  const cfg = Bidders.Main;
  const isSuperUser = hasRoleSuperUser(user.user);

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [key, setKey] = useState(0);

  // other consts
  const readAuthorization = IS_AUTHORIZED(['read_bidder'], user.user);
  const writeAuthorization = IS_AUTHORIZED(['write_bidder'], user.user);

  const handleChangeTab = (_event: React.SyntheticEvent, index: number) => {
    const tabKey = cfg.tabs.find((tab) => tab.value === index)?.key;
    track(`Bidder List - View ${tabKey} Tab`, { isSuperUser }, user.user);
    setActiveTabIndex(index);
  };

  const forceUpdate = (tabIndex: number): void => {
    unstable_batchedUpdates(() => {
      setActiveTabIndex(tabIndex);
      setKey((value) => value + 1);
    });
  };

  return (
    <BiddersListContext.Provider
      value={{
        cfg,
        readAuthorization,
        writeAuthorization,
        forceUpdate,
      }}
    >
      <Panels max vertical relative minWidthMain>
        <Panel largeHorizontalPadding smallVerticalPadding>
          <TopBar
            title='Bidder Management'
            enableUINotices
            tKey={'ItemManagement'}
            tProps={{ item: t('Bidder') }}
          />
        </Panel>
        <Panel>
          <SimpleTabs
            activeTabIndex={activeTabIndex}
            ariaLabel='Bidders'
            handleChangeTab={handleChangeTab}
            tabs={cfg.tabs}
          />
        </Panel>
        <Panel scroll paddingTop={spacing.small}>
          <SimpleTabSections
            key={key}
            activeTabIndex={activeTabIndex}
            sections={[
              <BiddersListView />,
              <BidderGroupsListView />,
              <BiddersDemandSourceSettings />,
            ]}
          />
        </Panel>
      </Panels>
    </BiddersListContext.Provider>
  );
};
